import CourseRecommendPage from './page';

export default function CourseRecommendPreview() {
  return <CourseRecommendPage />;
}